import { Button } from "@/components/ui/button";
import { Share2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

interface ShareButtonProps {
  resultCount: number;
}

export default function ShareButton({ resultCount }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    // Get current URL with all parameters
    const shareUrl = window.location.href;
    
    try {
      // Try to use native share API if available (mobile)
      if (navigator.share) {
        await navigator.share({
          title: 'Mushroom Clinical Research Database',
          text: `Check out these ${resultCount} clinical trials on medicinal mushrooms`,
          url: shareUrl
        });
        toast.success("Shared successfully!");
      } else {
        // Fallback to clipboard copy
        await navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        toast.success("Link copied to clipboard!");
        
        // Reset copied state after 2 seconds
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      }
    } catch (error) {
      // If clipboard API fails, show the URL in a toast
      toast.info("Share this link:", {
        description: shareUrl,
        duration: 5000
      });
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleShare}
      className="gap-2 border-[#A98A2C] text-[#A98A2C] hover:bg-[#F4F2EC] transition-colors"
    >
      {copied ? (
        <>
          <Check className="w-4 h-4" />
          Copied!
        </>
      ) : (
        <>
          <Share2 className="w-4 h-4" />
          Share Results
        </>
      )}
    </Button>
  );
}
